import Loader from "@/components/Loader";
import SecondaryButton from "@/components/SecondaryButton";
import SpheronCircleLogo from "@/assets/spheron-logo-circle.svg";

interface IProps {
  firstText: JSX.Element;
  secondText: JSX.Element;
  ctaText: JSX.Element;
  onCtaClick: () => void;
  isLoading?: boolean;
}

const MainSpheronSection = ({
  firstText,
  secondText,
  ctaText,
  onCtaClick,
  isLoading,
}: IProps) => {
  return (
    <div className="flex flex-col gap-y-6 items-center border border-[#333] bg-[#141416] lg:w-[512px] w-[95%] py-[60px] px-6">
      <div>
        <SpheronCircleLogo />
      </div>
      <div className="flex flex-col gap-y-[46px] leading-6 text-[#9D9D9D] text-center">
        <p>{firstText}</p>
        <p>{secondText}</p>
      </div>
      <div className="relative">
        {isLoading ? (
          <Loader />
        ) : (
          <SecondaryButton
            onClick={() => {
              onCtaClick();
            }}
            className="px-8 py-4 w-max"
            variant="light"
          >
            {ctaText}
          </SecondaryButton>
        )}
      </div>
    </div>
  );
};

export default MainSpheronSection;
